import React from "react";

export interface BaseContainerProps {
  childElement: React.JSX.Element;
}

const AthenaLogo = (): React.JSX.Element => {
  return (
    <div className="okta-sign-in-header auth-header" style={{ border: "none" }}>
      <h1>
        <img
          src="https://ok5static.oktacdn.com/fs/bco/1/fs013y6epzdVeejbd298"
          className="auth-org-logo"
          alt="Athenahealth Inc. logo logo"
          aria-label="Athenahealth Inc. logo logo"
        />
      </h1>
      <div
        data-type="beacon-container"
        className="beacon-container"
        style={{ transform: "scale(0, 0)", textIndent: "0px" }}
      ></div>
    </div>
  );
};

const BaseContainer = ({
  childElement,
}: BaseContainerProps): React.JSX.Element => {
  return (
    <div id="layout">
      <div id="main-container">
        <div id="inner-container">
          <div id="okta-login-container" style={{ marginTop: "0px" }}>
            <main
              data-se="auth-container"
              id="okta-sign-in"
              className="auth-container main-container no-beacon rounded-border"
            >
              <AthenaLogo />
              <div className="header-divider okta-form-divider form-divider"></div>
              <div className="auth-content">
                <div className="auth-content-inner">{childElement}</div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BaseContainer;
